/* eslint-disable react/jsx-key */

import Color from '../Color.mjs'
import IconLetters from '../icons/IconLetters.jsx'
import IconIs from './icon-is.svg?react'

export default [
    [
        'COMMON',
        '通用',

        <IconLetters
            fill={Color.LIGHT_YELLOW}
            letters="R"
            textColor="#000"
        />
    ],

    [
        'IS',
        '数据对象',
        <IconIs />
    ],

    [
        'DE',
        '数据实体',

        <IconLetters
            borderColor="transparent"
            borderWidth={20}
            fill={Color.CYAN}
        />
    ],

    [
        'DS',
        '数据权限',
        null,
    ],
]
